import { TSpace } from '@valuecase/common'

export const getSpaceUrl = (space: TSpace, showActivityFeed = false) => {
  const url = new URL(location.origin)
  url.pathname = `/spaces/${space.rootNodeId}`
  if (space.authToken) {
    url.searchParams.set('token', space.authToken)
  }
  if (showActivityFeed) {
    url.searchParams.set('openActivityFeed', 'true')
  }
  return url.toString()
}

export const copySpaceLink = (space: TSpace) => {
  const url = getSpaceUrl(space)
  navigator.clipboard.writeText(url)
  return url
}

export const createGetUrlWithToken =
  () => (spaceId: string, token?: string, showActivityFeed?: boolean) => {
    const url = new URL(location.origin)
    url.pathname = `/spaces/${spaceId}`
    if (token) url.searchParams.set('token', token)
    if (showActivityFeed) url.searchParams.set('openActivityFeed', 'true')
    return url.toString()
  }

export const openSpace = (spaceId: string, authToken?: string) => {
  const url = new URL(location.origin)
  url.pathname = `/spaces/${spaceId}`
  if (authToken) url.searchParams.set('token', authToken)
  window.open(url.toString(), '_blank')
}

export const copySpaceLinkWithToken = (spaceId: string, authToken?: string) => {
  const url = new URL(location.origin)
  url.pathname = `/spaces/${spaceId}`
  if (authToken) url.searchParams.set('token', authToken)
  navigator.clipboard.writeText(url.toString())
  return url.toString()
}

export const openBlock = ({
  spaceId,
  authToken,
  blockId,
  pageId,
}: {
  spaceId: string
  authToken?: string
  blockId?: string
  pageId?: string
}) => {
  const url = new URL(location.origin)
  url.pathname = `/spaces/${spaceId}`
  if (authToken) {
    url.searchParams.set('token', authToken)
  }
  if (pageId) {
    url.searchParams.set('page', pageId)
  }
  if (blockId) {
    url.searchParams.set('block', blockId)
  }
  console.log('url', url.toString())
  window.open(url.toString(), '_blank')
}
